import SelectionProjectOfferPage from './selection-project-offer-page';
export default SelectionProjectOfferPage;